import domain from '../domain';

/**
 * 沙盘侧边栏切换回列表模式
 */
export const backToListMode = domain.event();
